import { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Accordion from 'react-bootstrap/Accordion';
import Nav from 'react-bootstrap/Nav';
import { VscFolderActive } from 'react-icons/vsc';



const ReportsSidebar = ( { sidebarConfig, selectedReportId, onSelectReport } ) => {
    const [ activeKey, setActiveKey ] = useState('');

    useEffect( () => {
        if ( !sidebarConfig ) {
            return;
        }
        setActiveKey( sidebarConfig.filter( f => f.reports?.length ).map( m => m.id ) );
    }, [ sidebarConfig ] );

    return (
        <Container fluid className='p-0' style={ { height: '100%' } }>
            <Row className='tf-section-container ms-4 me-0 p-0' style={ { height: '100%' } }>
                <Card style={ { height: '100%' } }>
                    <Card.Body className='p-0 pt-1'>
                        <Card.Title className='pt-1'>
                            <Row>
                                <Col>
                                    <VscFolderActive />
                                    <span className='ps-2 fw-bold fs-6'>Reports</span>
                                </Col>
                            </Row>
                        </Card.Title>
                        <Row>
                            <Col className='px-0'>
                                <Accordion activeKey={activeKey} onSelect={setActiveKey} alwaysOpen>
                                {
                                    sidebarConfig.map( ( section ) => (
                                        <Accordion.Item eventKey={section.id} key={`report-section-${section.id}`}>
                                            <Accordion.Header>{section.header}</Accordion.Header>
                                            <Accordion.Body className="p-0">
                                                <Nav className="flex-column">
                                                {
                                                    section.reports.map( ( report ) => (
                                                        <Nav.Link
                                                            key={`report-section-${report.title}`}
                                                            active={ report.id === selectedReportId }
                                                            onClick={ () => onSelectReport( report ) }
                                                            className="ps-4 py-2 small"
                                                        >
                                                            {report.title}
                                                        </Nav.Link>
                                                    ) )
                                                }
                                                </Nav>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    ) )
                                }
                                </Accordion>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Row>
        </Container>
    );
};

const mapProps = ( state ) => ( {
    orgId: state.user.orgId,
    aid: state.user.aid,
    uid: state.user.email,
    user: state.user,
    grids: state.user.meta.datagrids,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    stack: state.user.stack,
    loans: state.loans.byId,
    contacts: state.contacts.byId,
    tasks: state.tasks.byId,
    notes: state.notes.byId,
    status: state.user.meta.loan.picklist.status
} );
  
const mapDispatch = ( dispatch ) => ( {
    setDatagridWidth: dispatch.user.setDatagridWidth,
    setDatagridOrder: dispatch.user.setDatagridOrder
} );
  
export default connect( mapProps, mapDispatch )( ReportsSidebar );